var _ = require('./lodash.min').runInContext();
module.exports = require('./fp/_baseConvert')(_, _);



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp.js
// module id = 359
// module chunks = 0